import { WSList } from "@wingspanhq/fe-component-library";
import { useRouteMatch } from "react-router-dom";
import { FlowAddPayoutMethod } from "../../Settings/components/payout/FlowAddPayoutMethod";
import { CardPayoutMethodRequirementRequester } from "../components/CardPayoutMethodRequirementRequester";
import { OnboardingStep } from "../types";

export const PayoutMethod: React.FC<OnboardingStep> = ({ onNext }) => {
  const match = useRouteMatch();

  return (
    <WSList gap="2XL">
      <CardPayoutMethodRequirementRequester />

      <FlowAddPayoutMethod basePath={match.path} onNext={onNext} />
    </WSList>
  );
};
